import { z } from 'zod';

export const activityFeedItemSchema = z.object({
  id: z.string(),
  source: z.enum(['transaction', 'notification']),
  created_at: z.string(),
  shop_id: z.string().uuid(),
  shop_latest_update_at: z.string().nullable(),
  brand_color: z.string(),
  business_name: z.string(),
  title: z.string(),
  text: z.string().nullable(),
  has_image: z.boolean(),
  transaction_type: z.number().nullable(),
});
export type ActivityFeedItem = z.infer<typeof activityFeedItemSchema>;

export const activityFeedResultsSchema = z.object({
  items: z.array(activityFeedItemSchema),
  hasMore: z.boolean(),
  nextPage: z.number().nullable(),
});
export type ActivityFeedResults = z.infer<typeof activityFeedResultsSchema>;
